import {Component, OnInit, Inject, ViewChild, AfterViewInit} from '@angular/core';
import {API_URL} from 'projects/core/src/public-api';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ProjectService} from '../../data/project/project.service';
import {GalleryItem, ImageItem, GalleryComponent} from 'ng-gallery';
import {timer} from 'rxjs';

@Component({
  selector: 'app-image-gallery-carousel',
  templateUrl: './image-gallery-carousel.component.html',
  styleUrls: ['./image-gallery-carousel.component.scss']
})
export class ImageGalleryCarouselComponent implements OnInit, AfterViewInit {
  dialogHeader: string;
  imageLinks: SafeResourceUrl[];

  showSourceButton = true;

  activeImg = 0;

  images: GalleryItem[];

  @ViewChild('galleryAngular')
  galleryAngular: GalleryComponent;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    protected projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) private data: {
      dialogHeader: string,
      clickedImageId: number,
      images: string[],
      showSourceButton: boolean;
    }
  ) {
    this.dialogHeader = data.dialogHeader;
    this.imageLinks = data.images.map(link => this.sanitizer.bypassSecurityTrustResourceUrl(`${this.apiUrl}${link}`));

    if (this.data.images) {
      this.images = this.data.images.map(img => {
        // tslint:disable-next-line: no-unused-expression
        return new ImageItem({src: `${this.apiUrl}${img}`})
      })

      this.data.images.forEach((img, index) => {
        const wordsArr = img.split('/')
        if (wordsArr[wordsArr.length - 1] === this.data.clickedImageId + '' || wordsArr[wordsArr.length - 2] === this.data.clickedImageId + '') {
          this.activeImg = index

          timer(1).subscribe(emit => {
            this.galleryAngular.set(this.activeImg);
          })
        }
      })
    }


    this.showSourceButton = data.showSourceButton;
  }

  ngOnInit() {

  }

  ngAfterViewInit() {

  }

  openImageInNewTab() {
    window.open(this.apiUrl + this.data.images[this.activeImg] + '/original')
  }

  indexChange(event) {
    this.activeImg = event.currIndex
  }

}
